export default __webpack_public_path__ + "static/media/starter.ed29784b.svg";